import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum ControllersErrorCode {
  UndefinedCompRef = 'UndefinedCompRef',
}

class ControllersError extends BaseError<ControllersErrorCode> {
  constructor(message: string, code: ControllersErrorCode) {
    super(message, code, 'Controllers Error');
  }
}

export const createControllersError = createErrorBuilder<
  ControllersErrorCode,
  ControllersError
>(ControllersError);
